import { useEffect, useState } from 'react';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export const useAreAllExpertiseValidated = (expertReport: ExpertReportType) => {
  const { victimExpertises, vehiculeExpertises } = expertReport;

  const [areExpertisesValidated, setAreExpertisesValidated] = useState<boolean>(
    false,
  );

  const canValidateExpertReport = [
    ...victimExpertises.filter(vi => !get(vi, 'isOld')),
    ...vehiculeExpertises.filter(ve => !get(ve, 'isOld')),
  ].every(
    exp =>
      exp.status === PROCEDURE_STATUSES.VALIDATED ||
      exp.status === PROCEDURE_STATUSES.CONTESTED,
  );

  useEffect(() => {
    setAreExpertisesValidated(canValidateExpertReport);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expertReport]);

  return [areExpertisesValidated];
};

export const useDisplayActionButtons = (expertReport: any) => {
  const canValidateExpertiseReport = [
    ...get(expertReport, 'victimExpertises', []),
    ...get(expertReport, 'vehiculeExpertises', []),
  ].some(
    (exp: any) =>
      (featureService.hasFeature(FEATURES.EVOLUTION_P1) ? true : !exp.isOld) &&
      (isEmpty(exp.status) ||
        exp.status === STATUS_PENDING ||
        (exp.status === STATUS_REJECTED &&
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER))),
  );

  return canValidateExpertiseReport;
};
